const experienceArray = [
  {
    id: 1,
    date: 'Feb 2025 - Present',
    title: 'Software Engineer',
    position: 'Internship',
    company: 'Nike',
    location: 'Bengaluru',
    description: {
      1: 'Automated CI/CD workflow using  Jenkins to handle web app linting, testing, building, and deployment.',
      2: 'Designed and implemented a cross-region backup solution using Terraform, Jenkins, Node.js, AWS, and DynamoDB, ensuring data resilience and disaster recovery.',
      3: 'Migrated the entire serverless ecosystem to Terraform with zero downtime, optimizing deployment and infrastructure management.',
      4: 'Integrated AWS Lambda and API Gateway for seamless, scalable, and cost-efficient service orchestration.'
    },
    skills: [
      'JavaScript',
      'Amazon EC2',
      'Docker',
      'AWS',
      'Jenkins',
      'CI/CD',
      'Testing',
      'Linting',
      'DevOps',
      'Infrastructure Automation',
      'Deployment'
    ]
  }
]

const positionOfResponsibilityArray = [
  {
    id: 1,
    date: 'Jan 2021- Present',
    title: 'Placement Coordinator, Training and Placement Cell, SGSITS ',
    position: '',
    company: 'SGSITS, Indore',
    location: 'Indore M.P.',
    description: {
      1: 'Coordinated companies during campus drives and facilitated student-company interactions.',
      2: 'Liaised with corporate recruitment teams to attract top companies for recruitment.',
      3: 'Managed placement and internship activities across all sectors in the Training and Placement Cell.'
    },
    skills: ['Communication', 'Leadership', 'Teamwork', 'Management', 'Git', 'GitHub', 'React', 'Nodejs']
  },
  {
    id: 2,
    date: '2018- 2019',
    title: 'House Captian',
    position: '',
    company: 'SECR ',
    location: 'Shahdol M.P.',
    description: {
      1:  'Directed as Yellow House Captain at SECR School, orchestrating and managing all house activities.',
      2: 'Oversaw and coordinated a range of events, competitions, and initiatives, showcasing leadership excellence.',
      3: 'Spearheaded efforts to promote school values and ethos through active participation and engagement in house activities.'
    },
    skills: ['Communication', 'Leadership', 'Teamwork', 'Management']
  }
]

export { experienceArray, positionOfResponsibilityArray }
